module.exports = __webpack_public_path__ + "img/16f7580f76.f7580f76.png";